import { buffer, featureCollection } from '@turf/turf'
import type { Feature, FeatureCollection, Polygon, MultiPolygon } from 'geojson'

/** Recorte aplicado ao shape da fazenda no processamento de imagens. */
export const CLIP_BUFFER_METERS = 50

export class FarmClipBufferProvider {
	/**
	 * Aplica o buffer de recorte ao shape da fazenda. Cada feature e bufferizada
	 * isoladamente para preservar fazendas com poligonos desconexos.
	 */
	static build(
		farm: FeatureCollection | Feature | null,
		meters: number = CLIP_BUFFER_METERS,
	): FeatureCollection<Polygon | MultiPolygon> {
		if (!farm) return featureCollection([])

		const features = farm.type === 'FeatureCollection' ? farm.features : [farm]

		const buffered: Feature<Polygon | MultiPolygon>[] = []

		for (const feature of features) {
			// O buffer do turf devolve undefined para geometrias que nao geram area.
			const result = buffer(feature as never, meters, { units: 'meters' })
			if (result) buffered.push(result as Feature<Polygon | MultiPolygon>)
		}

		return featureCollection(buffered)
	}
}
